module.exports = __webpack_public_path__ + "media/images/athletes/3405-dac5e784abef3062d8767c2ac94e3827.png";